module.exports = __webpack_public_path__ + "img/raton2.b23d6d3a.png";